// Mock Data for Net Gains Real Estate Website

export const properties = [
  {
    id: 1,
    title: { en: 'Luxury Penthouse - Downtown Dubai', ar: 'بنتهاوس فاخر - وسط مدينة دبي' },
    location: { en: 'Downtown Dubai', ar: 'وسط مدينة دبي' },
    price: 4500000,
    currency: 'AED',
    type: { en: 'Residential', ar: 'سكني' },
    category: { en: 'Sale', ar: 'للبيع' },
    beds: 4,
    baths: 5,
    area: 3500,
    image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750',
    featured: true,
    yield: '6.5%',
    description: {
      en: 'Stunning penthouse with panoramic views of Burj Khalifa and Dubai Fountain',
      ar: 'بنتهاوس مذهل مع إطلالات بانورامية على برج خليفة ونافورة دبي'
    }
  },
  {
    id: 2,
    title: { en: 'Modern Villa - Dubai Marina', ar: 'فيلا حديثة - دبي مارينا' },
    location: { en: 'Dubai Marina', ar: 'دبي مارينا' },
    price: 6200000,
    currency: 'AED',
    type: { en: 'Residential', ar: 'سكني' },
    category: { en: 'Sale', ar: 'للبيع' },
    beds: 5,
    baths: 6,
    area: 4200,
    image: 'https://images.unsplash.com/photo-1531971589569-0d9370cbe1e5',
    featured: true,
    yield: '7.2%',
    description: {
      en: 'Contemporary villa with private pool and marina views',
      ar: 'فيلا عصرية مع مسبح خاص وإطلالات على المارينا'
    }
  },
  {
    id: 3,
    title: { en: 'Grade A Office Space - DIFC', ar: 'مساحة مكتبية من الفئة أ - مركز دبي المالي العالمي' },
    location: { en: 'DIFC', ar: 'مركز دبي المالي العالمي' },
    price: 8500000,
    currency: 'AED',
    type: { en: 'Commercial', ar: 'تجاري' },
    category: { en: 'Sale', ar: 'للبيع' },
    area: 2800,
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800',
    featured: false,
    yield: '9.5%',
    description: {
      en: 'Premium office space in the heart of Dubai financial district',
      ar: 'مساحة مكتبية فاخرة في قلب المنطقة المالية بدبي'
    }
  },
  {
    id: 4,
    title: { en: 'Luxury Apartment - Palm Jumeirah', ar: 'شقة فاخرة - نخلة جميرا' },
    location: { en: 'Palm Jumeirah', ar: 'نخلة جميرا' },
    price: 3800000,
    currency: 'AED',
    type: { en: 'Residential', ar: 'سكني' },
    category: { en: 'Sale', ar: 'للبيع' },
    beds: 3,
    baths: 4,
    area: 2400,
    image: 'https://images.pexels.com/photos/5563473/pexels-photo-5563473.jpeg',
    featured: true,
    yield: '6.8%',
    description: {
      en: 'Exclusive beachfront apartment with stunning sea views',
      ar: 'شقة حصرية على الشاطئ مع إطلالات خلابة على البحر'
    }
  },
  {
    id: 5,
    title: { en: 'Retail Space - Dubai Mall District', ar: 'مساحة تجزئة - منطقة دبي مول' },
    location: { en: 'Downtown Dubai', ar: 'وسط مدينة دبي' },
    price: 5600000,
    currency: 'AED',
    type: { en: 'Commercial', ar: 'تجاري' },
    category: { en: 'Sale', ar: 'للبيع' },
    area: 1800,
    image: 'https://images.unsplash.com/photo-1519567241046-7f570eee3ce6?w=800',
    featured: false,
    yield: '11.2%',
    description: {
      en: 'Prime retail location with high foot traffic',
      ar: 'موقع تجزئة ممتاز مع حركة مرور عالية'
    }
  },
  {
    id: 6,
    title: { en: 'Off-Plan Villa - Arabian Ranches', ar: 'فيلا على الخارطة - أرابيان رانشز' },
    location: { en: 'Arabian Ranches', ar: 'أرابيان رانشز' },
    price: 4200000,
    currency: 'AED',
    type: { en: 'Residential', ar: 'سكني' },
    category: { en: 'Off-Plan', ar: 'على الخارطة' },
    beds: 4,
    baths: 5,
    area: 3800,
    image: 'https://images.pexels.com/photos/32870/pexels-photo.jpg',
    featured: false,
    yield: '7.5%',
    description: {
      en: 'Elegant villa in gated community with golf course',
      ar: 'فيلا أنيقة في مجتمع مسور مع ملعب غولف'
    }
  }
];

export const services = [
  {
    id: 1,
    title: { en: 'Commercial Properties', ar: 'العقارات التجارية' },
    description: { en: 'Warehouses, staff accommodation, retail spaces & Grade-A offices', ar: 'مستودعات، سكن موظفين، محلات تجزئة ومكاتب من الفئة أ' },
    yield: '8-12%',
    icon: 'Building2',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800'
  },
  {
    id: 2,
    title: { en: 'Residential Investment', ar: 'الاستثمار السكني' },
    description: { en: 'Luxury apartments, villas & off-plan opportunities', ar: 'شقق فاخرة، فلل وفرص على الخارطة' },
    yield: '6-8%',
    icon: 'Home',
    image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750'
  },
  {
    id: 3,
    title: { en: 'Market Analytics', ar: 'تحليلات السوق' },
    description: { en: 'Real-time data, trends & forecasts', ar: 'بيانات فورية، اتجاهات وتوقعات' },
    yield: 'Live',
    icon: 'TrendingUp',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71'
  },
  {
    id: 4,
    title: { en: 'Investment Advisory', ar: 'الاستشارات الاستثمارية' },
    description: { en: 'Expert guidance for your portfolio', ar: 'إرشادات خبراء لمحفظتك الاستثمارية' },
    yield: '24/7',
    icon: 'Users',
    image: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2'
  },
  {
    id: 5,
    title: { en: 'Off-Plan Projects', ar: 'المشاريع على الخارطة' },
    description: { en: 'Early investment opportunities with premium ROI', ar: 'فرص استثمارية مبكرة بعائد استثمار ممتاز' },
    yield: '5-8%',
    icon: 'Building',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800'
  },
  {
    id: 6,
    title: { en: 'Community Guides', ar: 'أدلة المجتمع' },
    description: { en: 'Comprehensive insights into Dubai communities', ar: 'رؤى شاملة عن مجتمعات دبي' },
    yield: '103+',
    icon: 'MapPin',
    image: 'https://images.pexels.com/photos/33953639/pexels-photo-33953639.jpeg'
  }
];

export const communities = [
  { id: 1, name: { en: 'Dubai Marina', ar: 'دبي مارينا' }, properties: 450, avgPrice: 1200000 },
  { id: 2, name: { en: 'Downtown Dubai', ar: 'وسط مدينة دبي' }, properties: 380, avgPrice: 1800000 },
  { id: 3, name: { en: 'Palm Jumeirah', ar: 'نخلة جميرا' }, properties: 320, avgPrice: 2500000 },
  { id: 4, name: { en: 'JVC', ar: 'مجمع جميرا' }, properties: 520, avgPrice: 850000 },
  { id: 5, name: { en: 'Business Bay', ar: 'الخليج التجاري' }, properties: 290, avgPrice: 1400000 },
  { id: 6, name: { en: 'Arabian Ranches', ar: 'أرابيان رانشز' }, properties: 180, avgPrice: 3200000 },
  { id: 7, name: { en: 'JBR', ar: 'جي بي آر' }, properties: 210, avgPrice: 1600000 },
  { id: 8, name: { en: 'Dubai Hills', ar: 'دبي هيلز' }, properties: 340, avgPrice: 2100000 }
];

export const marketStats = [
  {
    id: 1,
    value: 'AED 917B',
    label: { en: '2025 Total Transactions', ar: 'إجمالي المعاملات 2025' },
    source: { en: 'DLD Official', ar: 'دائرة الأراضي والأملاك' }
  },
  {
    id: 2,
    value: '+13%',
    label: { en: 'Residential Price Growth', ar: 'نمو أسعار العقارات السكنية' },
    source: { en: 'CBRE Q4 2025', ar: 'تقرير CBRE الربع الرابع 2025' }
  },
  {
    id: 3,
    value: '7.2%',
    label: { en: 'Peak Rental Yield', ar: 'ذروة العائد الإيجاري' },
    source: { en: 'Knight Frank', ar: 'نايت فرانك' }
  },
  {
    id: 4,
    value: '3.65%',
    label: { en: 'UAE Base Rate', ar: 'سعر الفائدة الأساسي بالإمارات' },
    source: { en: 'Current: Feb 2026', ar: 'الحالي: فبراير 2026' }
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Ahmed Al-Rashid',
    role: { en: 'Business Owner', ar: 'صاحب عمل' },
    rating: 5,
    text: {
      en: 'Professional service with deep market knowledge. Net Gains provided insights that no other consultant could offer. Highly recommended for serious investors.',
      ar: 'خدمة احترافية مع معرفة عميقة بالسوق. قدمت Net Gains رؤى لم يستطع أي مستشار آخر تقديمها. موصى به بشدة للمستثمرين الجادين.'
    },
    date: '2 months ago'
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    role: { en: 'International Investor', ar: 'مستثمرة دولية' },
    rating: 5,
    text: {
      en: 'As an international investor, I needed someone who understands both local and global markets. Net Gains exceeded my expectations with their strategic approach.',
      ar: 'كمستثمرة دولية، كنت بحاجة إلى شخص يفهم الأسواق المحلية والعالمية. تجاوزت Net Gains توقعاتي بنهجها الاستراتيجي.'
    },
    date: '3 weeks ago'
  },
  {
    id: 3,
    name: 'Fatima Abdullah',
    role: { en: 'Family Office', ar: 'مكتب عائلي' },
    rating: 5,
    text: {
      en: 'The best investment decision I made was consulting with Net Gains first. Their knowledge of both commercial and residential sectors is exceptional.',
      ar: 'أفضل قرار استثماري اتخذته هو التشاور مع Net Gains أولاً. معرفتهم بكل من القطاعات التجارية والسكنية استثنائية.'
    },
    date: '1 month ago'
  },
  {
    id: 4,
    name: 'James Robertson',
    role: { en: 'Developer', ar: 'مطور عقاري' },
    rating: 5,
    text: {
      en: 'Finally, a consultant who speaks the language of investors. The market analysis was institutional-grade, and the risk assessment saved me from a potentially bad investment.',
      ar: 'أخيراً، مستشار يتحدث لغة المستثمرين. كان تحليل السوق من الدرجة المؤسسية، وأنقذني تقييم المخاطر من استثمار سيء محتمل.'
    },
    date: '3 weeks ago'
  }
];

export const blogPosts = [
  {
    id: 1,
    title: { en: 'Best Areas for Families in Dubai 2026', ar: 'أفضل المناطق للعائلات في دبي 2026' },
    category: { en: 'Communities', ar: 'المجتمعات' },
    excerpt: {
      en: 'Discover the best family-friendly communities in Dubai with schools, parks, and amenities nearby.',
      ar: 'اكتشف أفضل المجتمعات الصديقة للعائلات في دبي مع المدارس والحدائق والمرافق القريبة.'
    },
    image: 'https://images.pexels.com/photos/33953639/pexels-photo-33953639.jpeg',
    readTime: '6 min',
    likes: 45
  },
  {
    id: 2,
    title: { en: 'Dubai Golden Visa: Complete Guide 2026', ar: 'التأشيرة الذهبية لدبي: دليل شامل 2026' },
    category: { en: 'Legal', ar: 'قانوني' },
    excerpt: {
      en: 'Everything about Dubai Golden Visa: eligibility, benefits, application process, and required documents.',
      ar: 'كل شيء عن التأشيرة الذهبية لدبي: الأهلية، الفوائد، عملية التقديم، والوثائق المطلوبة.'
    },
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c',
    readTime: '8 min',
    likes: 78
  },
  {
    id: 3,
    title: { en: 'Investment Strategies for Dubai Real Estate', ar: 'استراتيجيات الاستثمار للعقارات في دبي' },
    category: { en: 'Investment', ar: 'استثمار' },
    excerpt: {
      en: 'Learn proven strategies to maximize your ROI in Dubai real estate market.',
      ar: 'تعلم الاستراتيجيات المثبتة لتعظيم عائد الاستثمار في سوق العقارات بدبي.'
    },
    image: 'https://images.unsplash.com/flagged/photo-1559717201-fbb671ff56b7',
    readTime: '10 min',
    likes: 92
  },
  {
    id: 4,
    title: { en: 'Best International Schools in Dubai', ar: 'أفضل المدارس الدولية في دبي' },
    category: { en: 'Education', ar: 'تعليم' },
    excerpt: {
      en: 'Comprehensive guide to Dubai top international schools, including fees and curriculum.',
      ar: 'دليل شامل لأفضل المدارس الدولية في دبي، بما في ذلك الرسوم والمناهج.'
    },
    image: 'https://images.pexels.com/photos/31566720/pexels-photo-31566720.jpeg',
    readTime: '7 min',
    likes: 63
  }
];

export const clientLogos = [
  { id: 1, name: 'MH Food', logo: 'https://via.placeholder.com/120x60?text=MH+Food' },
  { id: 2, name: 'Euroclima', logo: 'https://via.placeholder.com/120x60?text=Euroclima' },
  { id: 3, name: 'Kids Tooth', logo: 'https://via.placeholder.com/120x60?text=Kids+Tooth' },
  { id: 4, name: 'BTL', logo: 'https://via.placeholder.com/120x60?text=BTL' },
  { id: 5, name: 'MisterBaker', logo: 'https://via.placeholder.com/120x60?text=MisterBaker' },
  { id: 6, name: 'Shakespeare & Co', logo: 'https://via.placeholder.com/120x60?text=Shakespeare' },
  { id: 7, name: 'Specta', logo: 'https://via.placeholder.com/120x60?text=Specta' },
  { id: 8, name: 'Almila', logo: 'https://via.placeholder.com/120x60?text=Almila' },
  { id: 9, name: 'NFPC', logo: 'https://via.placeholder.com/120x60?text=NFPC' }
];

export const investorServices = [
  {
    id: 1,
    title: { en: 'Sell Property', ar: 'بيع العقار' },
    description: { en: 'List your commercial or residential property', ar: 'أدرج عقارك التجاري أو السكني' },
    icon: 'Home'
  },
  {
    id: 2,
    title: { en: 'Rent Out Property', ar: 'تأجير العقار' },
    description: { en: 'Find quality tenants for your property', ar: 'ابحث عن مستأجرين جيدين لعقارك' },
    icon: 'Key'
  },
  {
    id: 3,
    title: { en: 'Investment Funding', ar: 'تمويل الاستثمار' },
    description: { en: 'Get financing for your investment', ar: 'احصل على تمويل لاستثمارك' },
    icon: 'DollarSign'
  },
  {
    id: 4,
    title: { en: 'Portfolio Management', ar: 'إدارة المحفظة' },
    description: { en: 'Professional property portfolio management', ar: 'إدارة احترافية لمحفظة العقارات' },
    icon: 'Briefcase'
  },
  {
    id: 5,
    title: { en: 'Legal Advisory', ar: 'استشارات قانونية' },
    description: { en: 'Expert legal guidance for transactions', ar: 'إرشادات قانونية خبيرة للمعاملات' },
    icon: 'Scale'
  },
  {
    id: 6,
    title: { en: 'Market Research', ar: 'أبحاث السوق' },
    description: { en: 'In-depth market analysis and reports', ar: 'تحليلات وتقارير متعمقة عن السوق' },
    icon: 'BarChart3'
  }
];
